import confetti, { create as createConfetti } from "canvas-confetti";

let end;
let myColors;
let fire; // non-worker instance

function ensureInstance() {
  if (typeof window === "undefined") return null;
  if (!fire) {
    try {
      // Avoid OffscreenCanvas/Worker to prevent CSP and cross-origin isolation issues
      fire = createConfetti(null, {
        useWorker: false,
        resize: true,
        disableForReducedMotion: true,
      });
    } catch (e) {
      // If create() fails for any reason, do not fallback to worker-based default
      fire = null;
    }
  }
  return fire;
}

export function launch(colors) {
  if (typeof window === "undefined") return;
  myColors = colors;
  end = Date.now() + 5 * 1000;
  boom();
}

function boom() {
  const inst = ensureInstance();
  if (!inst) return;
  const interval = setInterval(function () {
    if (Date.now() > end) {
      return clearInterval(interval);
    }
    inst({
      startVelocity: 30,
      particleCount: 100,
      spread: 360,
      ticks: 60,
      origin: { x: Math.random(), y: Math.random() - 0.2 },
      colors: myColors,
    });
  }, 200);
}
